import { render, staticRenderFns } from "./SuggestionBox.vue?vue&type=template&id=74ae63e8&scoped=true"
import script from "./SuggestionBox.vue?vue&type=script&lang=js"
export * from "./SuggestionBox.vue?vue&type=script&lang=js"
import style0 from "./SuggestionBox.vue?vue&type=style&index=0&id=74ae63e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ae63e8",
  null
  
)

/* custom blocks */
import block0 from "./SuggestionBox.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports